module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_15_1-5c25937f76ef138311a3cb6be6188965.svg";